import { SolidMerchantDataResponse } from 'api/types/payment';

import * as action from './actions';

import * as actionTypes from './actionTypes';

import { InferValueTypes } from 'types/commonTypes';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

export interface PaymentState {
    isMerchantDataLoading: boolean;
    solidMerchantData: SolidMerchantDataResponse | null;
}

const initialState = {
    isMerchantDataLoading: false,
    solidMerchantData: null,
};

const paymentReducer = (state: PaymentState = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.SET_SOLID_MERCHANT_DATA:
            return { ...state, solidMerchantData: action.payload };

        case actionTypes.SET_MERCHANT_LOADING:
            return { ...state, isMerchantDataLoading: action.payload };

        default:
            return state;
    }
};

export default paymentReducer;
